import { render, staticRenderFns } from "./GlucoseMeterBox.vue?vue&type=template&id=d653f838&scoped=true"
import script from "./GlucoseMeterBox.vue?vue&type=script&lang=js"
export * from "./GlucoseMeterBox.vue?vue&type=script&lang=js"
import style0 from "./GlucoseMeterBox.vue?vue&type=style&index=0&id=d653f838&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d653f838",
  null
  
)

export default component.exports